import { getAnalytics, logEvent as logToFirebase } from 'firebase/analytics';

export function logEvent(event: string) {
  logToFirebase(getAnalytics(), event);
}
